import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import type { ContentItemRenderVariantProps } from "~/components/content/content-item-render/types";
import type { homeLatestContentItemContent$key } from "~/queries/__generated__/homeLatestContentItemContent.graphql";

import {
  ActionBar,
  ActionBarContainer,
  Container,
  Headline,
  Section,
  StyledEntityLink,
} from "./styles";

export type Props = {
  reference: homeLatestContentItemContent$key;
} & ContentItemRenderVariantProps;

export const ContentItemHomeLatest = forwardRef<HTMLDivElement, Props>(
  ({ className, onClick, provider, reference: reference_ }, reference) => {
    const content = useFragment(
      graphql`
        fragment homeLatestContentItemContent on Content {
          ...entityLink
          entityId
        }
      `,
      reference_,
    );

    return (
      <Container className={className} ref={reference}>
        <ActionBarContainer>
          <ActionBar>
            {provider.actionBar({
              displayDateVariant: "publishedDate",
              isBookmarkVisible: false,
              isCommentsVisible: false,
              isIconVisible: false,
            })}
          </ActionBar>
          <Section>{provider.sections()}</Section>
        </ActionBarContainer>
        <StyledEntityLink reference={content} onClick={() => onClick?.(content.entityId)}>
          <Headline>
            {provider.headline({
              preferSocialHeadline: true,
            })}
          </Headline>
        </StyledEntityLink>
      </Container>
    );
  },
);

ContentItemHomeLatest.displayName = "ContentItemHomeLatest";
